import React from 'react';
import { scrollToCompra } from '../utils/scroll';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
  className?: string;
  pulse?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = true
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-montserrat font-black text-white bg-brand-green hover:bg-brand-greenDark transition-colors duration-150 rounded-lg px-5 py-4 text-base md:text-lg text-center uppercase tracking-wide shadow-lg';
  const widthClasses = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e);
    } else if (!href) {
      scrollToCompra(e);
    }
  };
  if (href) {
    return <a href={href} className={`${baseClasses} ${widthClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-24">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${widthClasses} ${className}`} data-id="element-25">
      {children}
    </button>;
}